import styled from '@emotion/styled';

export const Wrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;
  padding-top: 19px;
`;

export const ProvidersWrapper = styled.div`
  .row {
    align-items: center;

    input[type='checkbox'] {
      width: 16px;
      height: 16px;
    }
  }
`;

export const TableContainer = styled('div')`
  overflow-y: auto;
  overflow-x: auto;
  padding: 0 !important;
  min-height: 300px;
  max-height: 500px;

  .form-control[type='checkbox'] {
    width: 16px;
    height: 16px;
  }
`;
